/**
 *   Generated file. Do not edit
 */

import { ScramLoginParams } from './models';
import { ScramLoginResponseBody } from './models';
import { EncryptedIVRequest } from './models';
import { EncryptedIVResponse } from './models';
import { AbstractService, ServiceCallType } from '@iotize/tap';
import { TapRequestFrame } from '@iotize/tap/client/api';
import * as serviceConverters from './service-converters';
import { converters as commonConverters } from '@iotize/tap/service/core';

const allConverters = {
  ...commonConverters,
  ...serviceConverters,
};

export const SERVICE_CALLS = {
  login: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/scram/login',
    path: '/1024//40',
    responseBodyDecoder: allConverters.scramLoginResponseBody,
    bodyEncoder: allConverters.scramLoginParams,
  } as ServiceCallType<ScramLoginParams, ScramLoginResponseBody>,

  loginProof: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/scram/login-proof',
    path: '/1024//41',
  } as ServiceCallType<Uint8Array, Uint8Array>,

  getHashIteration: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/scram/hash-iteration',
    path: '/1024//42',
    responseBodyDecoder: allConverters.uint32,
  } as ServiceCallType<void, number>,

  putHashIteration: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/scram/hash-iteration',
    path: '/1024//42',
    bodyEncoder: allConverters.uint16,
  } as ServiceCallType<number, void>,

  initialize: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/scram/initialize',
    path: '/1024//47',
  } as ServiceCallType<void, Uint8Array>,

  stop: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/scram/stop',
    path: '/1024//46',
  } as ServiceCallType<void, Uint8Array>,

  send: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/scram/com-send-receive',
    path: '/1024//48',
  } as ServiceCallType<Uint8Array, Uint8Array>,

  setInitializationVector: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/scram/initialization-vector',
    path: '/1024//45',
  } as ServiceCallType<Uint8Array, Uint8Array>,

  sendWithIV: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/scram/send-with-iv',
    path: '/1024//44',
    responseBodyDecoder: allConverters.encryptedIVResponse,
    bodyEncoder: allConverters.encryptedIVRequest,
  } as ServiceCallType<EncryptedIVRequest, EncryptedIVResponse>,
};
